/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  AmenitiesInfo component
 */
/** @jsx jsx */
import { Box, useColorModeValue } from '@chakra-ui/react'
import { jsx } from '@emotion/react'
import type { Listable } from '@zcode/state-type'
import * as styles from './styles'

export interface Props {
  listable: Listable
  isMobile?: boolean
  isLargeCard?: boolean
}

export const AmenitiesInfo = ({ listable, isMobile, isLargeCard }: Props) => {
  const amenitiesList = listable.combinedAmenities
  const color = useColorModeValue('gray.600', 'gray.100')
  if (amenitiesList.length === 0) {
    return null
  }
  const MAX_VISIBLE_AMENITIES = isLargeCard ? 9 : 5
  const amenitiesText: Array<(typeof amenitiesList)[number] | `${number} more`> =
    amenitiesList.slice(0, MAX_VISIBLE_AMENITIES)
  const truncateItems = isLargeCard ? amenitiesText.length > 5 : amenitiesText.length > 3
  if (amenitiesList.length > MAX_VISIBLE_AMENITIES) {
    amenitiesText.push(`${amenitiesList.length - MAX_VISIBLE_AMENITIES} more`)
  }
  return (
    <div
      css={[
        isLargeCard ? styles.amenitiesColumnSectionLarge : styles.amenitiesColumnSection,
        isMobile && styles.amenitiesColumnSectionMobile,
      ]}
    >
      {amenitiesText.map((amenity) => (
        <Box<'div'>
          color={color}
          fontSize="sm"
          key={amenity}
          maxWidth={truncateItems ? 'calc(50% - 4px)' : undefined}
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {amenity}
        </Box>
      ))}
    </div>
  )
}
